import { Controller } from "@hotwired/stimulus"

// Shows a panel only while a select holds a given value — the admin duplicate
// form's "New country…" fields. Hidden fields are disabled, so a form never
// submits half-filled values the server would have to ignore, and their
// required attributes never block a submit nobody can see.
export default class extends Controller {
  static targets = ["source", "panel"]
  static values = { match: String }

  connect() {
    this.toggle({ focus: false })
  }

  toggle({ focus = true } = {}) {
    const shown = this.sourceTarget.value === this.matchValue

    this.panelTarget.hidden = !shown
    this.fields.forEach((field) => { field.disabled = !shown })
    if (shown && focus) this.fields[0]?.focus()
  }

  get fields() {
    return Array.from(this.panelTarget.querySelectorAll("input, select, textarea"))
  }
}
